window._ = require('lodash');

window.axios = require('axios');

window.plupload = require('plupload');

window.moment = require('moment');

window.qs = require('qs');

window.Noty = require('noty');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// require intersection observer to solve error on ios devices
require('intersection-observer');

import Echo from 'laravel-echo'

window.Pusher = require('pusher-js');

window.Echo = new Echo({
    broadcaster: 'pusher',
    key: process.env.MIX_PUSHER_APP_KEY,
    cluster: process.env.MIX_PUSHER_APP_CLUSTER,
    forceTLS: true
});